(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _PublicLibrary = require("../../common/PublicLibrary");

var _PublicLibrary2 = _interopRequireDefault(_PublicLibrary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function initializeLibrary(instance) {
  if (instance.library === null) {
    instance.library = new _PublicLibrary2.default(instance.catalog);
  }
}

var PublicLibraryVirtualProxy = function () {
  function PublicLibraryVirtualProxy() {
    var catalog = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];

    _classCallCheck(this, PublicLibraryVirtualProxy);

    this.library = null;
    this.catalog = catalog;
  }

  _createClass(PublicLibraryVirtualProxy, [{
    key: "findBooks",
    value: function findBooks(query) {
      console.log("Enter findBooks PublicLibraryVirtualProxy");
      initializeLibrary(this);
      return this.library.findBooks(query);
    }
  }, {
    key: "checkoutBook",
    value: function checkoutBook(book) {
      initializeLibrary(this);
      return this.library.checkoutBook(book);
    }
  }, {
    key: "returnBook",
    value: function returnBook(book) {
      initializeLibrary(this);
      return this.library.returnBook(book);
    }
  }]);

  return PublicLibraryVirtualProxy;
}();

exports.default = PublicLibraryVirtualProxy;

},{"../../common/PublicLibrary":3}],2:[function(require,module,exports){
'use strict';

var _PublicLibraryVirtualProxy = require('./PublicLibraryVirtualProxy');

var _PublicLibraryVirtualProxy2 = _interopRequireDefault(_PublicLibraryVirtualProxy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var oVirtualProxyLibrary = new _PublicLibraryVirtualProxy2.default();
oVirtualProxyLibrary.findBooks('test');

},{"./PublicLibraryVirtualProxy":1}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PublicLibrary = function () {
  function PublicLibrary(books) {
    _classCallCheck(this, PublicLibrary);

    this.catalog = {};
    this.setCatalogFromBooks(books);
  }

  _createClass(PublicLibrary, [{
    key: 'setCatalogFromBooks',
    value: function setCatalogFromBooks(books) {
      var _this = this;

      books.forEach(function (book) {
        _this.catalog[book.getIsbn()] = {
          book: book,
          available: true
        };
      });
    }
  }, {
    key: 'findBooks',
    value: function findBooks(query) {
      console.log("Enter findBooks PublicLibrary");
      var results = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.catalog[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var book = _step.value;

          if (query.match(book.getTitle()) || query.match(book.getAuthor())) {
            results.push(book);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return results;
    }
  }, {
    key: 'checkoutBook',
    value: function checkoutBook(book) {
      var isbn = book.getIsbn();
      book = this.catalog[isbn];
      if (book) {
        if (book.available) {
          book.available = false;
          return book;
        } else {
          throw new Error('PublicLibrary: book ' + book.getTitle() + ' is not currently available.');
        }
      } else {
        throw new Error('PublicLibrary: book ' + book.getTitle() + ' not found.');
      }
    }
  }, {
    key: 'returnBook',
    value: function returnBook(book) {
      var isbn = book.getIsbn();
      book = this.catalog[isbn];
      if (book) {
        book.available = true;
      } else {
        throw new Error('PublicLibrary: book ' + book.getTitle() + ' not found.');
      }
    }
  }]);

  return PublicLibrary;
}();

exports.default = PublicLibrary;

},{}]},{},[2])

